//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment'

export default {
  auth: false,
  layout: 'front-page',
  data: () => ({
    current_page: 1,
    last_page: 0,
    eventsNear: [],
    eventsNew: []
  }),
  mounted () {
    this.loadEvent()
    this.loadNear()
  },
  methods: {
    async loadEvent (cat) {
      const params = {
        current_page: this.current_page
      }

      const result = await this.$axios.get('/api/event/list', { params })
      this.eventsNew = this.eventsNew.concat(result.data.data)
      this.last_page = result.data.last_page
    },
    async more () {
      this.current_page++
      await this.loadEvent()
    },
    tanggal (date1, date2) {
      moment.locale('id') // indonesia
      return moment(date1).format('ddd, DD MMM') + ' - ' + moment(date2).format('ddd, DD MMM')
    },
    async loadNear () {
      const params = { per_page: 4 }

      await this.$axios
        .$get('/api/event/near', {
          params
        })
        .then((data) => {
          this.eventsNear = data.data
        })
        .catch(() => {})
        .finally(() => {
        })
    }
  }
}
